'use client'

import type { ReactNode } from 'react'
import { Ninxl8BitThemeProvider, useNinxl8BitTheme } from '@/app/(marketing)/_components/8bit'
import { NinOrgFooter } from '@/app/nin/_components/nin-org-footer'
import { NinOrgNav } from '@/app/nin/_components/nin-org-nav'

function ShellContent({ children }: { children: ReactNode }) {
  const { theme } = useNinxl8BitTheme()
  return (
    <div className="ninxl-8bit min-h-screen bg-white" data-ninxl-theme={theme}>
      <NinOrgNav />
      {children}
      <NinOrgFooter />
    </div>
  )
}

export function CmsPublicShell({ children }: { children: ReactNode }) {
  return <Ninxl8BitThemeProvider><ShellContent>{children}</ShellContent></Ninxl8BitThemeProvider>
}

